module.exports = new __parcel__URL__("fiery-lava 128x128.16b67982.png").toString();